import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Container, Title, Text, Button, Group } from "@mantine/core";
import { IconArrowLeft, IconHome, IconCompassOff } from "@tabler/icons-react";
import "./styles.css";

const NotFound404 = () => {
  const navigate = useNavigate();

  useEffect(() => {
    document.title = "Page Not Found | Virel Admin";
  }, []);

  return (
    <div className="not-found-page">
      <div className="not-found-background">
        <div className="orb orb-1"></div>
        <div className="orb orb-2"></div>
        <div className="orb orb-3"></div>
        <div className="grid-overlay"></div>
      </div>

      <Container size="md" className="content-wrapper">
        <div className="code-container">
          <div className="error-code-glow"></div>
          <h1 className="error-code">404</h1>
        </div>

        <Group justify="center" gap="xs" mb="md">
          <IconCompassOff size={24} color="#94a3b8" />
          <Text
            size="sm"
            tt="uppercase"
            fw={700}
            c="dimmed"
            style={{ letterSpacing: 2 }}
          >
            Page Not Found
          </Text>
        </Group>

        <Title order={2} c="white" size="h1" mb="lg">
          Lost in the <span style={{ color: "#19752e" }}>Digital Void?</span>
        </Title>

        <Text c="dimmed" size="lg" maw={500} mx="auto" mb={40}>
          The mission you're looking for seems to have expired or never existed.
          Let's get you back to verified territory.
        </Text>

        <div className="divider-line"></div>

        <Group justify="center" gap="md">
          <Button
            size="lg"
            variant="default"
            className="back-button"
            leftSection={<IconArrowLeft size={20} />}
            onClick={() => navigate(-1)}
            radius="md"
          >
            Go Back
          </Button>

          <Button
            size="lg"
            variant="filled"
            color="brand"
            leftSection={<IconHome size={20} />}
            onClick={() => navigate("/d")}
            radius="md"
            style={{
              boxShadow: "0 4px 20px rgba(108, 77, 255, 0.4)",
            }}
          >
            Return Home
          </Button>
        </Group>
      </Container>
    </div>
  );
};

export default NotFound404;
